import React from 'react';
import ContactForm from '../components/forms/ContactForm';

const Contact = () => {
    return(
        <>
        <div className='Contact'>
            <ContactForm />
        </div>
        </>
    );
}

export default Contact;